module.exports = __webpack_public_path__ + "static/media/deploy-Icon.472619a5.svg";